import { FormOutlined } from '@ant-design/icons';
import { Button } from '@g2u/ui-kit';
import { type ChatActionHandler } from './types';

export const CreateTicketAction: ChatActionHandler = {
  type: 'CREATE_TICKET',
  render: (payload, helpers) => {
    if (!payload?.title) return null;
    return (
      <Button.$
        dataTestId="ai-action-create-ticket"
        type={Button.Type.Primary}
        size={Button.Size.Small}
        icon={<FormOutlined />}
        onClick={() => helpers.onCreateTicket(payload.title)}
      >
        Create Ticket
      </Button.$>
    );
  },
};
